/*
  Correcoes globais para todos os carrosseis Splide do tema.
  Carregado como module logo depois do splide-*.js e antes do Alpine (index-*.js),
  entao ja vale para todo `new Splide(...).mount()` das secoes e dos cards.

  1) "Imagem dividida com a proxima": o Splide posiciona a lista em PIXELS
     (translateX(-664px)) e so recalcula no evento `resize` da JANELA. Quando so o
     container muda de largura (barra de rolagem aparece depois do load, CSS/fonte
     atrasada, carrossel montado escondido, card trocado de cor), a lista fica com o
     deslocamento antigo e mostra metade de um slide e metade do proximo.
     Aqui um ResizeObserver no root dispara `resize` no proprio Splide, que so refaz
     o layout se o tamanho do track realmente mudou.

  2) "Imagem que nao carrega / demora": as imagens dos slides fora da tela sao
     loading="lazy", e o lazy nativo nao carrega o que esta cortado pelo
     overflow:hidden do track -- so baixa quando o slide ja entrou na tela (fica em
     branco no swipe). Aqui, quando o carrossel esta perto da viewport, as imagens
     da pagina atual e da vizinha (anterior/proxima) passam a eager.
*/
(function () {
  var Splide = window.Splide
  if (!Splide || Splide.prototype.__uzFix) return
  Splide.prototype.__uzFix = true

  var mount = Splide.prototype.mount

  function isAlive(splide) {
    return splide.root && splide.root.isConnected && splide.root.classList.contains('is-initialized')
  }

  function watchResize(splide) {
    if (!('ResizeObserver' in window)) return
    // ResizeObserver ja agrupa por frame; o Layout do Splide ignora se o tamanho nao mudou.
    var observer = new ResizeObserver(function () {
      if (isAlive(splide)) splide.emit('resize')
    })
    observer.observe(splide.root)
  }

  function preloadNearby(splide) {
    var visible = false

    function run() {
      if (!visible || !isAlive(splide)) return
      var total = splide.length
      if (!total) return
      var perPage = splide.options.perPage || 1
      var radius = Math.ceil(perPage) // uma pagina de cada lado
      var current = splide.index

      splide.Components.Slides.get().forEach(function (slide) {
        var distance = Math.abs(slide.index - current)
        if (splide.options.type === 'loop') distance = Math.min(distance, total - distance)
        if (distance > radius) return
        slide.slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
          // Em carrossel aninhado (card dentro do carrossel de produtos), so a foto que
          // o card esta mostrando; as escondidas ficam por conta do proprio card.
          var owner = img.closest('.splide')
          if (owner !== splide.root) {
            var inner = img.closest('.splide__slide')
            if (!inner || !inner.classList.contains('is-active') || inner.classList.contains('splide__slide--clone')) return
          }
          img.loading = 'eager'
        })
      })
    }

    splide.on('mounted move resized', run)

    // Mini-carrossel de fotos do card: numa grade de 48 cards, pre-carregar as fotos
    // escondidas de todo card visivel disputa banda com a foto principal e deixa a
    // grade mais lenta. Ali so pre-carrega quando a pessoa demonstra interesse.
    if (splide.root.closest('.product-card')) {
      var onIntent = function () {
        visible = true
        run()
      }
      ;['pointerenter', 'touchstart', 'focusin'].forEach(function (type) {
        splide.root.addEventListener(type, onIntent, { once: true, passive: true })
      })
      return
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[entries.length - 1].isIntersecting
          run()
        },
        { rootMargin: '400px 0px' }
      ).observe(splide.root)
    } else {
      visible = true
    }
  }

  // 3) Videos com autoplay dentro de slide que comeca fora da tela nunca iniciam sozinhos
  //    (ficam com readyState 0 mesmo quando o slide aparece), e os dos cards agora vem
  //    com preload="none" + data-uz-autoplay (snippets/card-video.liquid). Toca o video
  //    do slide visivel e pausa os demais, so enquanto o carrossel esta na tela.
  var VIDEO_SELECTOR = 'video[autoplay], video[data-uz-autoplay]'

  function syncVideos(splide) {
    var root = splide.root
    if (!root.querySelector(VIDEO_SELECTOR)) return
    var onScreen = false

    function run() {
      if (!root.isConnected) return
      // Card com uma midia so monta com destroy:true (sem carrossel): o unico slide conta como visivel.
      var mounted = root.classList.contains('is-initialized')
      root.querySelectorAll(VIDEO_SELECTOR).forEach(function (video) {
        // carrossel de produtos contem os carrosseis dos cards: cada um cuida dos seus
        if (video.closest('.splide') !== root) return
        var slide = video.closest('.splide__slide')
        var show = onScreen && (!mounted || (slide && slide.classList.contains('is-visible')))
        if (show) {
          if (!video.paused) return
          video.muted = true
          var playing = video.play()
          if (playing && playing.catch) playing.catch(function () {})
        } else if (!video.paused) {
          video.pause()
        }
      })
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          onScreen = entries[entries.length - 1].isIntersecting
          run()
        },
        { threshold: 0.25 }
      ).observe(splide.root)
    } else {
      onScreen = true
    }

    splide.on('mounted moved', run)
  }

  Splide.prototype.mount = function () {
    var alreadyMounted = this.__uzWatched
    var result = mount.apply(this, arguments)
    if (!alreadyMounted && this.root) {
      this.__uzWatched = true
      watchResize(this)
      preloadNearby(this)
      syncVideos(this)
    }
    return result
  }
})()
